const NotFound: React.FC = () => {
  return (
    <>
      <h2>お探しのページは見つかりませんでした。</h2>
    </>
  )
}

export default NotFound
